import { ProgressSpinner } from "primereact/progressspinner";

export default function LoadingSpinner() {
  return (
    <div className="flex justify-content-center align-items-center p-4">
      <ProgressSpinner className="w-5rem h-5rem" strokeWidth="3" />
    </div>
  );
}
